import React from "react";
import "./Policy.css";
const RefundPolicy = () => {
  return (
    <div className="policyContainer">
      <div className="policyHead">
        <h2>
          Refund <span>Policy</span>
        </h2>
      </div>
      <div className="policyContent">
        <ul>
          <li>
            The course fee must be paid in full at least 7 days prior to the
            commencement of the course. Admission would be given on a first come
            first serve basis.
          </li>
          <li>
            Fee once paid is valid for a period of three months before which the
            course has to be completed or else the admission stands canceled and
            the fee will not be refunded.
          </li>
          <li>
            If the student wishes to withdraw the admission due to any medical
            emergencies or other reasons, then the same can be done before the
            batch start date. A processing fee of Rs 2500/- will be deducted on
            such refunds. After the batch commences, no refunds will be
            provided.
          </li>
          <li>
            Prizma Academy reserves the right to change the trainer of any
            ongoing batch at any point in time.
          </li>
          <li>
            In the case of private classes, the start dates and end dates would
            have to be strictly adhered to. Any missed classes/re-scheduling’s
            have to be completed within the same month and cannot be carried
            forward. The end date will not be changed for any reason.
          </li>
          <li>
            Any class cancellations/rescheduling for private classes have to be
            informed at least two days in advance. If the same is informed on
            the day of the class or if the trainer has logged in and the student
            does not show up for the class, then he/she is marked absent and no
            compensation class will be provided.
          </li>
          <li>
            A minimum attendance of 80% is required to be eligible to take up
            the Prizma Academy examination at the end of the course.
          </li>
          <li>
            Video recordings are not part of the course. The same, if any, will
            be shared only at discretion, and the same, if any links shared will
            expire after a maximum period of 15 days or after the batch end
            date.
          </li>
          <li>
            Transfer from one batch to another batch or transfer of course from
            one individual to another individual would be entertained only
            before the commencement of the course. The same would be decided
            based on the availability of seats in the desired batch .
          </li>
          <li>
            Prizma Academy reserves the right to make changes to the offers and
            schedules as necessary. Prizma Academy is not responsible for the
            privacy and confidentiality of online transactions.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default RefundPolicy;
